// 用户的头像和昵称
<template>
  <div class="self-avator">
    <div class="avator-img">
      <img :src="userInfo.avator" class="user-avator-img" alt="" srcset="" />
    </div>
    <div class="username">{{ userInfo.nickname || userInfo.username }}</div>
  </div>
</template>

<script>
export default {
  name: "Avator",
  computed: {
    userInfo: function () {
      return this.$store.getters.getUserInfo;
    },
  },
};
</script>

<style lang="less" scoped>
.self-avator {
  display: flex;
  flex-direction: column;
  .avator-img {
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover{
      filter: contrast(1.1);
    }
    .user-avator-img {
      width: 200px;
      height: 200px;
      border-radius: 50%;
      box-shadow: 10px 10px 100px #ffffff;
    }
  }
  .username {
    margin: 1rem;
    font-size: 2rem;
    text-align: center;
  }
}
</style>
